export default "__VITE_ASSET__CEYHAVVv__"